<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Add Ribbon</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card  class="addadmin">
      <label class="inviteuser">New Ribbon</label>
      <div [formGroup]="ribbonForm">
    <div class="row">
        <mat-form-field  class="container mt-3" appearance="outline">
            <input formControlName="first_name" matInput placeholder="Ribbon Name">
          </mat-form-field>
      </div>
      <div class="row">  
        <form #addressForm="ngForm" class="container mt-3">
          <!-- some code here - see full code at the end of this tutorial -->
          <section *ngFor="let tag of tags; let i = index;">
            <!-- input fields inside the *ngFor -->
            <mat-form-field appearance="outline">
              <mat-label>Tag</mat-label>
              <input matInput type="text" [(ngModel)]="tag.tags" name="tag_{{i}}">
            </mat-form-field>
  
          </section>
          <form>
            <!-- Add button -->
            <span style="cursor:pointer" (click)="addAddress()" class="material-icons">
              add_circle
            </span>
            <!-- ngFor code -->
          </form>
        </form>
    </div>
    </div>
    <div class="row">
        <div class="container mt-3">
        <button mat-raised-button #ignoredButton (click)="toggle=!toggle">Pick Color</button>  
        <input style="margin-left: 15px;"
        disabled
        #ignoredInput
        [value]="color"
        [style.background]="color"
        [cpIgnoredElements]="[ignoredButton, ignoredInput]"
        [(cpToggle)]="toggle"
        [(colorPicker)]="color"
        [cpOKButton]="true"
        [cpOKButtonClass]= "'btn btn-primary btn-xs'"
        (colorPickerSelect)="changedColor($event)"/>

</div>
</div>

  <button class="addbutton" (click)="addRibbon()" mat-flat-button color="primary">Add Ribbon</button>
</mat-card>


